import React from 'react'

import './Styles.css'

const RealCaseCard = ({ image, name, testimonial }) => {
  return (
    <div className="real-case-card">
      <img className="picture" src={image} alt={name} />
      <div className="content">
        <p className="name">{name}</p>
        <p className="testimonial">{testimonial}</p>
      </div>
    </div>
  )
}

export default RealCaseCard
